<template>
    <b-container>
        <b-input v-model="doc.title" class="mb-2"></b-input>
        <div
            class="text-danger"
            style="margin-top:-8px; margin-bottom: 10px"
            v-if="validation.hasError('doc.title')"
        >
            The title is required
        </div>
        <div class="doceditor">
            <ckeditor :editor="editor" v-model="doc.body" :config="editorConfig"></ckeditor>

            <b-button variant="primary" class="float-right mt-2" @click="saveForm()">
                <font-awesome-icon :icon="['fa-solid', 'fa-floppy-disk']" /> Save Doc
            </b-button>
        </div>
    </b-container>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DocDataService from '@/services/DocDataService';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

export default {
    props: ["list"],
    data() {
        return {
            doc: {
                title: '',
                body: ''
            },
            editor: ClassicEditor,
            editorConfig: {}
        };
    },
    mixins: [SimpleVueValidation.mixin], // Attach the validation plugin
    validators: {
        'doc.title': function (value) {
            return Validator.value(value).required('The title is required');
        },
    },
    created() {
        if (this.$route.query.clone !== undefined) {
            DocDataService.getById(this.$route.query.clone).then((res) => {
                this.doc.title = res.data.title;
                this.doc.body = res.data.body;
                this.$validate();
                // set the html document title to Clone Doc
                document.title = 'Clone Doc - ' + res.data.title;
            });
        }
    },
    methods: {
        saveForm() {
            this.$validate().then((success) => {
                if (!success) {
                    return; // Stop if validation fails
                }

                DocDataService.create({
                    title: this.doc.title,
                    body: this.doc.body,
                    set_deleted: 0,
                }).then((resp) => {
                    window.location = '/doc/' + resp + '?create=success';
                });
            });
        },
    },
};
</script>
<style>
.doceditor .ck-editor__editable {
    min-height: 73vh !important;
}
</style>